'use strict';

import angular from 'angular';
// import ngAnimate from 'angular-animate';
import ngCookies from 'angular-cookies';
import ngResource from 'angular-resource';
import ngSanitize from 'angular-sanitize';

import uiRouter from 'angular-ui-router';
import uiBootstrap from 'angular-ui-bootstrap';
// import ngMessages from 'angular-messages';
// import ngValidationMatch from 'angular-validation-match';

import ngFileUpload from 'ng-file-upload';
import toaster from 'angularjs-toaster';
import ngLoadingBar from 'angular-loading-bar';


import {
  routeConfig
} from './app.config';

import _Auth from '../components/auth/auth.module';
import account from './account';
import admin from './admin';
import navbar from '../components/navbar/navbar.component';
import footer from '../components/footer/footer.component';
import constants from './app.constants';
import util from '../components/util/util.module';

import firmwares from './firmwares';
import betausers from './betausers';
import apps from './apps';
import jdOrder from './jdOrder';
import appstore from './appstore';
import appIconCheck from './filters/app-icon-check.filter';
import waveforms from './waveforms';

import booklist from './booklist';
import appconfs from './appconfs'
import betagroups from './betagroups';

import groupName from './filters/group-name.filter';

import userManual from './usermanual';

import dictionaries from './dictionaries';

import devices from './devices';

import myscripts from './myscripts';

import categories from './categories';

import carousel from './carousel';

import writetpl from './writeTpl';

import screenSaver from './screenSaver';
import appconfgroups from './appconfgroups';

import tutorial from './tutorial';

import peripheral from './peripheral';

import fonts from './fonts';

import DeviceCert from './devicecert';

import tpFirmwares from './tpFirmwares';

import monitor from './monitor'

import keyboard from './keyboard'

import DeviceConfigs from './deviceconfigs'

import Tags from './tags'

import './app.scss';

import $ from '../assets/libs/jquery.min.js';
window.$ = window.jQuery = $;
import 'bootstrap/dist/js/bootstrap';
require('../assets/libs/summernote/summernote.js');
require('../assets/libs/summernote/summernote.css');
require('../assets/libs/summernote/angular-summernote.js');

angular.module('updateServerApp', [ngCookies, ngResource, ngSanitize, uiRouter, uiBootstrap, _Auth, ngFileUpload, toaster, ngLoadingBar,
  account, admin, navbar, footer, constants, util, firmwares, betausers, apps, jdOrder, appstore, appIconCheck, waveforms, booklist, appconfs, betagroups, groupName,
  userManual, dictionaries, devices, myscripts, categories, carousel, writetpl, screenSaver, appconfgroups, tutorial, peripheral, fonts, DeviceCert, tpFirmwares, monitor,
  keyboard, DeviceConfigs, Tags, 'summernote'
])
  .config(routeConfig)
  .config(['cfpLoadingBarProvider', function(cfpLoadingBarProvider) {
    cfpLoadingBarProvider.includeSpinner = false;
  }])
  .run(function($rootScope, $location, Auth) {
    'ngInject';
    // Redirect to login if route requires auth and you're not logged in

    $rootScope.$on('$stateChangeStart', function(event, next) {
      Auth.isLoggedIn(function(loggedIn) {
        if(next.authenticate && !loggedIn) {
          $location.path('/login');
        }
      });
    });
  });

angular.element(document)
  .ready(() => {
    angular.bootstrap(document, ['updateServerApp'], {
      strictDi: true
    });
  });



// WEBPACK FOOTER //
// ./client/app/app.js